import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { DiscordUser, getStoredAuth, isAuthenticated as checkAuth, getUser as getUserFromStore, loginWithDiscord, logout } from './discord'

type AuthContextValue = {
  isAuthenticated: boolean
  user: DiscordUser | null
  login: () => Promise<void>
  logout: () => void
}

const AuthContext = createContext<AuthContextValue | undefined>(undefined)

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(checkAuth())
  const [user, setUser] = useState<DiscordUser | null>(getUserFromStore())

  useEffect(() => {
    const interval = setInterval(() => {
      const auth = getStoredAuth()
      const valid = auth ? Date.now() < auth.expiresAt - 5000 : false
      setIsAuthenticated(valid)
      setUser(valid ? auth?.user || null : null)
    }, 2000)
    return () => clearInterval(interval)
  }, [])

  const value = useMemo<AuthContextValue>(() => ({
    isAuthenticated,
    user,
    login: async () => {
      await loginWithDiscord()
    },
    logout: () => {
      logout()
      setIsAuthenticated(false)
      setUser(null)
      // Перенаправляем на главную страницу
      window.location.hash = ''
    },
  }), [isAuthenticated, user])

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export const useAuth = (): AuthContextValue => {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}

